import React, { useState, useEffect, useContext } from "react";
import "./Dashboard.styles.css";

import supportImage from "../../assets/images/ai-support-removebg-preview.png";
import welcomeImage from "../../assets/images/welcome_content.jpeg";
import logo from "../../assets/images/dark-logo.png";
import { GiBookCover } from "react-icons/gi";
import { CiGift } from "react-icons/ci";
import { FaDesktop } from "react-icons/fa6";

import pngImage from "../../assets/images/image-gallery.png";

import Swal from "sweetalert2";
import axios from "axios";
import GetToken from "../../GetToken";
import { handleInvalidToken } from "../../AuthUtils";
import { useNavigate, useParams, Link } from "react-router-dom";
import AnimationSpinner from "../../AnimationSpinner";
import AppContext from "antd/es/app/context";

// reqct and bootstrap imports
import { PiBuildingBold } from "react-icons/pi";
import { LuFolderKanban } from "react-icons/lu";
import { LuLayoutGrid } from "react-icons/lu";
import { FaLaptop } from "react-icons/fa6";
import { Users } from "react-feather"


// icons data import from other local file
import icons from '../../icon'
import { toast } from "react-toastify";

const Dashboard = (props) => {
	const navigate = useNavigate();
	const [totalAITalkingBooks, setTotalAITalkingBooks] = useState(0);
	const [totalAIPhotoBooks, setTotalAIPhotoBooks] = useState(0);
	const [totalAIFlipBooks, setTotalAIFlipBooks] = useState(0);
	const [totalAIBookTemplate, setTotalAIBookTemplate] = useState(0);
	const [demoVideo, setDemoVideo] = useState("");
	const [loading, setLoading] = useState(false);
	const avatar = localStorage.getItem("avatar") ?? null;
	const userName = localStorage.getItem("username") ?? null;
	const email = localStorage.getItem("email") ?? null;
	const { base_url } = useContext(AppContext);

	const DynamicIcon = ({ name, className, alt = "icon" }) => {
		return icons[name] ? (
			<div className="icon-image-container" style={{ width: "28px", height: "28px", overflow: "hidden", marginRight: "10px" }}>
				<img src={icons[name]} className={className} alt={alt} style={{ width: "100%", height: "100%", objectFit: "contain" }} />
			</div>
		) : null;
	};


	useEffect(() => {
		const fetchDashboardData = async () => {
			try {
				const token = GetToken();
				if (!token) {
					handleInvalidToken(navigate);
					return;
				}
				// setLoading(true)
				const formData = new FormData();
				formData.append("action", "getDashbordDetails");
				formData.append("token", token);

				const response = await axios.post(
					`${props.base_url}api/user/get-user-resource`,
					formData
				);

				if (response.data.status) {
					setLoading(false);
					setTotalAITalkingBooks(response.data.totalAITalkingBooks);
					setTotalAIPhotoBooks(response.data.totalAIPhotoBook);
					setTotalAIFlipBooks(response.data.totalAIFlipBooks)
					setTotalAIBookTemplate(response.data.totalAIBookTemplate)
					setDemoVideo(response.data.video);
				} else {
					if (response.data.reset) {
						setLoading(false);
						handleInvalidToken(navigate);
					} else {
						toast.error(response.data.message);
						// Swal.fire({
						// 	icon: "error",
						// 	title: "Error",
						// 	text: response.data.message,
						// });
					}
				}
			} catch (error) {
				setLoading(false);
				toast.error(error.response?.data?.message ||
					error.message ||
					"Something went wrong. Please try again.");
				// Swal.fire({
				// 	icon: "error",
				// 	title: "Error",
				// 	text:
				// 		error.response?.data?.message ||
				// 		error.message ||
				// 		"Something went wrong. Please try again.",
				// });
			}
		};

		fetchDashboardData();
	}, [navigate, props.base_url]);


	const quickLinks = [
		{ name: "Lets Create", icon: FaLaptop, url: "#", className: "link1" },
		{ name: "Lets Create", icon: FaLaptop, url: "#", className: "link2" },
		{ name: "Lets Create", icon: FaLaptop, url: "#", className: "link3" },
		{ name: "Lets Create", icon: FaLaptop, url: "#", className: "link4" },
		{ name: "Lets Create", icon: FaLaptop, url: "#", className: "link5" },
	];

	return (
		<>
			<div className="container p-0">
				<AnimationSpinner show={loading} />
				<div className="right-container px-4 px-md-5">
					<div className="welcome-container mb-4">
						<div className="row">
							<div className="col-lg-8 col-md-12 mb-3">
								<div className="welcome-content" >
									<div className="row">
										<div className="col-lg-7">
											<h1>Welcome to Bookflow AI </h1>
											<p>
												World's First AI App That Creates Stunning Talking Books In Any Language Or Niche In 60 Seconds Without Writing A Single Words Yourself.
											</p>

											<Link to="/book/create/talking_book">
												<button className="btn btn-primary">Get Started</button>
											</Link>
										</div>
										<div className="col-lg-5 d-none d-lg-block"
											style={{
												backgroundImage: `url(${welcomeImage})`,
												backgroundSize: 'cover',
												backgroundPosition: 'right',
												backgroundRepeat: "no-repeat",
												height: "200px"
											}}
										>

										</div>
									</div>
								</div>
							</div>
							<div className="col-lg-4 col-md-12 mb-3">
								<div className="assist-container">
									<div className="assist-content">
										<h3>How we can Assist You?</h3>
										<p>
											Explore our comprehensive articles and FAQs for quick
											answers to common questions.
										</p>
										<Link to="https://helpsoftdealslab.tawk.help/" target="_blank">
											<button className="btn btn-primary">Get Started</button>
										</Link>
									</div>
									<div className="support-image">
										<img src={supportImage} alt="Support-img" />
									</div>
								</div>
							</div>
						</div>
					</div>


					{/* counts area end */}
					{/* counts area start */}
					<div className="quick-links-container mx-auto my-5 mt-sm-4  mb-sm-1">
						<div className="row border-2 border-white">
							{[
								{ title: "AI Talking Book", icon: PiBuildingBold, count: totalAITalkingBooks, color: "primary", img: icons["dTBook"] },
								{ title: "AI FlipBook", icon: LuFolderKanban, count: totalAIFlipBooks, color: "success", img: icons["dFBook"] },
								{ title: "AI PhotoBook", icon: Users, count: totalAIPhotoBooks, color: "warning", img: icons["dPBook"] },
								{ title: "AI Book Templates", icon: LuLayoutGrid, count: totalAIBookTemplate, color: "info", img: icons["dCover"] },
							].map((stat, index) => (
								<div key={index} className="col-lg-3 col-md-6 col-sm-6 mb-3">
									<div className="db-cc-cnt position-relative">
										<div className="dashboard-count-card d-flex justify-content-between  align-items-end mb-4 mb-lg-3">
											<div className="d-flex w-100 justify-content-around align-items-center mb-2 py-2">
												<h6 className="m-0" style={{ fontSize: "22px", fontWeight: "600" }}>{stat.title}</h6>
												<p className="m-0" style={{ fontSize: "20px", fontWeight: "500" }}>{stat.count}</p>
											</div>
											<div className={`dashboard-gradient-card bg-${stat.color}`}></div>
										</div>
										<div className={`db-cc-img-cnt bg-${stat.color}`}>
											<img src={stat.img} alt={stat.title} />
										</div>
									</div>
								</div>
							))}
						</div>
					</div>
					{/* counts area end */}

					<div className="row">
						{/* demo video start */}
						<div className="col-lg-8 col-md-12 mb-4 ">
							<div className="introduction-content bg-white">
								<h4>Welcome to demo video</h4>
								{/* <div className="logo-container-ds w-100 h-100 d-flex justify-content-center align-items-center">
									<img src={logo} alt="Bookflow AI" className="img-fluid" />
								</div> */}
								<div className="embed-responsive embed-responsive-16by9">
									<iframe
										src={demoVideo}
										frameBorder="0"
										allow="autoplay; fullscreen; picture-in-picture"
										allowFullScreen
									></iframe>
								</div>
							</div>
						</div>
						{/* demo video end */}

						{/* quick links start */}
						<div className="col-lg-4 col-md-12 mb-4">
							<div className="quick-links-div bg-white">
								<h6 className="main-title">Quick links</h6>
								<div className="d-flex justify-content-center align-items-center flex-wrap gap-3">
									{[
										{ name: "AI Talking Book", icon: icons["mTBook"], url: "/book/create/talking_book", className: "link1" },
										{ name: "AI FlipBook", icon: icons["mFBook"], url: "/book/create/flipbook", className: "link2" },
										{ name: "AI PhotoBook", icon: icons["mPBook"], url: "/book/create/photobook", className: "link3" },
										{ name: "AI Book Template", icon: GiBookCover, url: "/book/template", className: "link4" },
										{ name: "Bonuses", icon: CiGift, url: "#", className: "link5" },
										{ name: "Training Videos", icon: FaDesktop, url: "/training-videos", className: "link5" },

									].map((link, index) => (


										<Link key={index} className="card1 shadow-sm" to={link.url}>
											{typeof link.icon === "string" ? (
												<img src={link.icon} alt={link.title} style={{ height: "25px", width: "25px", marginBottom: "10px" }} />
											) : (
												<link.icon style={{ height: "25px", width: "25px", marginBottom: "10px" }} />
											)}
											<p className="mb-0 h6 qk-link-title">{link.name}</p>
											<div className="go-corner" >
												<div className="go-arrow text-white">
													→
												</div>
											</div>
										</Link>
									))}
								</div>
							</div>
						</div>
						{/* quick links end */}
					</div>
				</div>
			</div >
		</>
	);
};

export default Dashboard;
